import SignaturePad from "@/components/signature/SignaturePad"
import VueSignaturePad from "vue-signature-pad"

export default {
    install(Vue) {
        Vue.use(VueSignaturePad)
        Vue.component("SignaturePad", SignaturePad)
    },
}
